import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import Molecule from "../../components/Molecule";
import { FilteredListProvider } from "../../context/filteredList";
import AppShell from "../../layout/AppShell";
import CompareFeaturePlansPage from "./CompareFeaturePlansPage";
import PricingPage from "./PricingPage";

interface Props extends RouteComponentProps {}

const PricingPageContainer: React.FC<Props> = (props) => (
  <FilteredListProvider>
    <AppShell
      {...props}
      className="h-auto sm:h-auto"
      currentPage={
        <div className="flex items-center">
          <span>Pricing</span>
        </div>
      }
    >
      <Molecule className="fixed right-0" />

      <Switch>
        <Route
          path="/pricing/compare-feature-plans"
          component={CompareFeaturePlansPage}
        />
        <Route path="/pricing" component={PricingPage} />
        <Redirect from="*" to="/pricing" />
      </Switch>
    </AppShell>
  </FilteredListProvider>
);

export default PricingPageContainer;
